import React from 'react';
import { Select } from 'antd';

const ControlSelect = ({ options, ...rest }) => (
  <Select options={options} {...rest} />
);

export default ControlSelect;